export function eur(v: number | null | undefined): string {
  if (v === null || v === undefined || Number.isNaN(v)) return '—';
  return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(v);
}

export function date(v: string | null | undefined): string {
  if (!v) return '—';
  const d = v.length === 10 ? new Date(`${v}T12:00:00`) : new Date(v);
  return d.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function dateTime(v: string | null | undefined): string {
  if (!v) return '—';
  return new Date(v).toLocaleString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function pct(v: number | null | undefined): string {
  return v === null || v === undefined ? '—' : `${v.toLocaleString('es-ES', { maximumFractionDigits: 1 })} %`;
}

export function iban(v: string | null | undefined): string {
  return v ? v.replace(/(.{4})/g, '$1 ').trim() : '—';
}

export function today(): string {
  return new Date().toISOString().slice(0, 10);
}

export function addDays(iso: string, n: number): string {
  const d = new Date(`${iso}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}

export const STATUS_TONE: Record<string, string> = {
  received: 'info', processing: 'info', review: 'warn', pending_approval: 'brand', approved: 'ok', rejected: 'error',
  exported: 'ok', scheduled: 'brand', paid: 'ok', cancelled: '',
};

export const STATUS_LABEL: Record<string, string> = {
  received: 'Recibida', processing: 'Leyendo', review: 'En revisión', pending_approval: 'Pendiente de aprobación', approved: 'Aprobada',
  rejected: 'Rechazada', exported: 'Contabilizada', scheduled: 'Pago programado', paid: 'Pagada', cancelled: 'Anulada',
};

export const FIELD_LABEL: Record<string, string> = {
  invoice_number: 'Número', issue_date: 'Fecha', due_date: 'Vencimiento', 'supplier.nif': 'NIF proveedor', 'supplier.name': 'Proveedor',
  'totals.base': 'Base', 'totals.tax': 'Cuota', 'totals.total': 'Total', iban: 'IBAN', account: 'Cuenta', cost_center: 'Centro de coste',
  taxes: 'Impuestos', withholding: 'Retención', 'customer.nif': 'NIF cliente',
};
